export default __webpack_public_path__ + "atomic/_patterns/02-molecules/social_share_links/_social_share_links.twig";